'use strict';

import { Carousel } from './carouselRefactor/carousel';

function isValid() {
  return (document.querySelector( '.cms-carousel-rsp' ) !== null);
}

function getDOMEl(selector) {
  return document.querySelector(selector);
}

function getViewportWidth() {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

function setNavigationButtonPosition(carouselName) {
  const [ prevBtn, nextBtn, firstImage ] = [
    getDOMEl(`.${carouselName}-swiper-button-prev`),
    getDOMEl(`.${carouselName}-swiper-button-next`),
    getDOMEl(`.${carouselName}__item-image-container`)
  ];
  if(getViewportWidth() < 768) {
    const btnY = firstImage.offsetHeight / 2;
    prevBtn.style.top = btnY + 'px';
    nextBtn.style.top = btnY + 'px';
  } else {
    if (prevBtn && prevBtn.hasAttribute('style')) {
      prevBtn.removeAttribute('style');
    }
    if (nextBtn && nextBtn.hasAttribute('style')) {
      nextBtn.removeAttribute('style');
    }
  }
}

function initCarousels(){
  for(let container of document.querySelectorAll('.cms-carousel-rsp')){
    new createCarousel(container);
  }
}

function createCarousel(container) {
  var cmsCarousel = new Carousel(
    {
      carousel_container 		: container, // required
      carousel_name 				: 'cms-carousel-rsp',
      slidesPerView 				: 1,
      slidesPerGroup 				: 1,
      pip_type 							: 'circles',
      display_pips 					: true,
      effect                : 'slide',
      pip_clickable 				: true,
      display_arrows 				: true,
      allow_zoom 						: false,
      loop  			          : true,
      autoplay              : 4000,
      allow_deletion 				: false,
      keyboardControl       : true,
      enlargeView           : false,
      nextSlideMessage      : 'Next',
      prevSlideMessage      : 'Previous',
      items_data 						: 'page',
      items_select					: [
        '.cms-carousel-rsp__item'
      ],
      remove_elements 			: [
        '.cms-carousel-rsp__item'
      ]
    }
  );
  window.onload = () => {
    setNavigationButtonPosition(cmsCarousel.carousel_name);
  };
  window.onresize = () => {
    //TODO: do this better
    setTimeout(() => {
      setNavigationButtonPosition(cmsCarousel.carousel_name);
    }, 250);
  }
}

if(isValid()) {
  initCarousels();
}

export {
  initCarousels
};
